<!--分享-->
<template>
  <div class="agree_foot">
    <div class="agree-btns">
      <div v-if="[0, 1].includes(isAgree)" :class="{ agreeDisabled: isAgree === 1, agree: true }" @click="agree(1)">需要</div>
      <div v-if="[0, 2].includes(isAgree)" :class="{ disagreeDisabled: isAgree === 2, disagree: true }" @click="agree(2)">不需要</div>
    </div>
  </div>
</template>

<script>
import {
  reqAISessionClickStatus,
} from '@/api/aiAssistant/index';
import { AIPlatform } from '@/utils/tools';

export default {
  components: {},
  data() {
    return {
      isAgree: 0,
    };
  },
  props: {
    footerInfo: {
      type: Object,
      default: () => { },
    },
  },
  computed: {},
  watch: {
    footerInfo: {
      handler(v) {
        if (v?.isAgree) {
          this.isAgree = v.isAgree;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    agree(type) {
      console.log('this.footerInfo', this.footerInfo);
      if (this.isAgree !== 0) return;
      this.isAgree = type;
      this.$emit('agreeCallBack', type);
      reqAISessionClickStatus({
        clickStatus: type,
        connectId: this.footerInfo.connectId,
        sourcePort: AIPlatform(), // 来源端口 1 PC 2 H5 3 小程序 4 IOS 5 安卓 6 ipad
      });
    },
  },
  created() { },
  mounted() { },
};
</script>
<style lang="scss" scoped>
.agree_foot {
  width: 620px;
  margin-top: 22px;
  padding-top: 16px;
  border-top: 2px solid #EFEFEF;
}
.agree-btns {
  display: flex;
  flex-direction: row-reverse;
}

.agree {
  width: 115.94px;
  height: 50.72px;
  margin-left: 14px;
  color: #ffffff;
  font-weight: 400;
  font-size: 22px;
  font-style: normal;
  line-height: 50px;
  text-align: center;
  border-radius: 22px;
  background: linear-gradient( 130deg, #FF7F41 0%, #FF4F25 100%);
}

.agreeDisabled {
  font-weight: 500;
  color: #FF7F41;
  background: rgba(255, 127, 65, .1);
}

.disagree {
  width: 115.94px;
  height: 50.72px;
  color: #999;
  font-weight: 400;
  font-size: 22px;
  font-style: normal;
  line-height: 50px;
  text-align: center;
  border: 1px solid #999;
  border-radius: 22px;
}
.disagreeDisabled {
  background: rgba(241, 242, 246, 1);
  //border: 1px solid rgba(241, 242, 246, 1);
}
</style>
